"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Layer;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _layersManager = require("./layers-manager.js");

var __jsx = _react["default"].createElement;

var LayerComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LayerComponent, _React$Component);

  function LayerComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, LayerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(LayerComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      container: null
    });
    return _this;
  }

  (0, _createClass2["default"])(LayerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onMount = _this$props.onMount,
          mountNode = _this$props.mountNode;

      if (mountNode) {
        onMount && onMount();
        return;
      } // There was no LayersManager added if this.props.host === undefined.
      // Use document.body is the case no LayersManager is used.


      var host = this.props.host !== undefined ? this.props.host : document.body;

      if (host) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          host = _this$props2.host,
          mountNode = _this$props2.mountNode;

      if (mountNode) {
        return;
      }

      if (host && host !== prevProps.host && prevProps.host === null) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var container = this.state.container;
      var _this$props3 = this.props,
          host = _this$props3.host,
          onUnmount = _this$props3.onUnmount;
      onUnmount && onUnmount();
      host && container && host.contains(container) && host.removeChild(container);
    }
  }, {
    key: "addContainer",
    value: function addContainer(host) {
      var _this$props4 = this.props,
          index = _this$props4.index,
          mountNode = _this$props4.mountNode,
          onMount = _this$props4.onMount; // Do nothing if mountNode is provided

      if (mountNode) {
        return;
      }

      if (host) {
        var container = host.ownerDocument.createElement("div");
        var sibling = typeof index === "number" ? host.children[index] : null;
        sibling ? host.insertBefore(container, sibling) : host.appendChild(container);
        this.setState({
          container: container
        }, function () {
          onMount && onMount();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.state.container;
      var _this$props5 = this.props,
          children = _this$props5.children,
          mountNode = _this$props5.mountNode;

      if (__BROWSER__) {
        if (mountNode || container) {
          // $FlowFixMe
          return _reactDom["default"].createPortal(children, mountNode || container);
        }

        return null;
      }

      return null;
    }
  }]);
  return LayerComponent;
}(_react["default"].Component);

function Layer(props) {
  return __jsx(_layersManager.Consumer, null, function (_ref) {
    var host = _ref.host;
    return __jsx(LayerComponent, (0, _extends2["default"])({}, props, {
      host: host
    }));
  });
}